// !!!!!!!!!!!!!!!!!!!!!!!!!!!
// !! GENERATED FILE. Do not edit manually. Run bin/generateLocalizedStrings.js instead
// !!!!!!!!!!!!!!!!!!!!!!!!!!!
/* eslint-disable quotes */
export default {
  "ABOUT": "Über",
  "ABOUT_API_TAB": "API",
  "ABOUT_VERSION": "Version",
  "ABOUT_EXTENSIS_URL": "www.portfoliodam.com",
  "ABOUT_PORTFOLIO_SERVER": "Portfolio-Server",
  "ABOUT_PORTFOLIO_VERSION": "Version 9.0",
  "ABOUT_SERVER_TAB": "Server",
  "accessOriginals": "Auf Originale zugreifen und verarbeiten",
  "ACCOUNT_TYPE": "Echtheitsbestätigung",
  "ACCOUNT_TYPE_LDAP": "Verzeichnisdienst",
  "ACCOUNT_TYPE_MANUAL": "Nativ (integriert)",
  "ACTIVE_DIRECTORY": "Active Directory",
  "ADD": "Hinzufügen",
  "ALL_CATALOGS_GROUP": "Alle Kataloge",
  "API_CODE_REFERENCE": "API-Code-Referenzmaterial (English)",
  "API_CODE_REFERENCE_URL": "https://doc.portfoliodam.com/api/portfolio/index.html",
  "API_DEVELOPER_COMMUNITY": "Entwicklergemeinde",
  "API_DEVELOPER_COMMUNITY_URL": "https://forums.portfoliodam.com/c/digital-asset-management/portfolio-api-developer-community",
  "API_PORTFOLIO_HELP": "Portfolio Administration – Hilfe",
  "API_PORTFOLIO_HELP_URL": "https://helpdocs.portfoliodam.com/de/portfolio/administration/{version}/index.htm",
  "API_SECTION_1": "Die Portfolio API stellt eine allgemeine Schnittstelle für Entwickler bereit. Sie dient zur Integrierung von Portfolio-Katalogen, Inventar-Metadaten und Medienverarbeitung für Geschäftssysteme, benutzerdefinierte Arbeitsabläufe und Internet-Infrastrukturen.",
  "API_SECTION_2_PART_1": "Für die Nutzung der API sind Lizenzen erforderlich ",
  "API_SECTION_2_EULA": "wie in der EULA beschrieben",
  "API_SECTION_2_EULA_URL": "https://helpdocs.portfoliodam.com/portfolio/{version}/administration/de/Content/Legal/extensis-portfolio-eula.htm",
  "API_SECTION_2_PART_2": ". Zum Anzeigen bzw. Bearbeiten der Lizenzinformationen klicken Sie in der Portfolio Administration-Anwendung auf 'Lizenzen'.",
  "API_SECTION_2_PART_3": "Mehr lernen:",
  "API_TOKEN_CREATE": "Fügen Sie einen neuen API Token hinzu",
  "APPLY": "Anwenden",
  "APP_PAGE_TITLE": "Portfolio-Administrator",
  "AT_TIME": "Uhrzeit",
  "AUTHENTICATION_ERROR": "Fehler bei der Verzeichnisservice-Authentifikation. Prüfen Sie Benutzernamen und Passwort.",
  "BACKUP_BACKUP_BUTTON": "Datensicherung",
  "BACKUP_BACKUP_LABEL": "Datensicherung",
  "BACKUP_BACKUP_NOW_BUTTON": "Jetzt Daten sichern",
  "BACKUP_CONFIGURATION_SERVER_RUNNING_MESSAGE": "Wenn Sie den Backup Speicherort ändern möchten, fahren Sie zuerst den Portfolio Server herunter.",
  "BACKUP_CONFIRMATION_VERBIAGE": "Jetzt Daten sichern? Bis die Datensicherung abgeschlossen ist, wird Portfolio wird offline sein.",
  "BACKUP_DIRECTORY_LABEL": "In Verzeichnis speichern",
  "BACKUP_DIRECTORY_ERROR_MSG": "Das ausgewählte Datensicherungsverzeichnis ist ungültig.",
  "BACKUP_EXPLANATION_TEXT_1": "Backups erfassen und die Server-Datenbank und Einstellungen sicher abspeichern. \nlt erstellt kein Backup Ihrer ursprünglichen Asset-Dateien!",
  "BACKUP_EXPLANATION_TEXT_2": "Während der Datensicherung kann nicht auf den Server zugegriffen werden.",
  "BACKUP_FRIDAY_LABEL": "Freitag",
  "BACKUP_MONDAY_LABEL": "Montag",
  "BACKUP_MOST_RECENT_LABEL": "Neuste Datensicherung",
  "BACKUP_NEXT_SCHEDULED_LABEL": "Nächste planmäßige Datensicherung",
  "BACKUP_NOTIFICATIONS": "E-Mail-Benachrichtigungen nach Backups und Wiederherstellungen senden",
  "BACKUP_NOTIFICATIONS_DISABLED_MSG": "E-Mail Benachrichtigungen müssen in den globalen Einstellungen> E-Mail Benachrichtigungen, aktiviert sein",
  "BACKUP_PROGRESS_BACKING_UP": "Datensicherung läuft",
  "BACKUP_PROGRESS_BACKING_UP_DATA": "Daten werden gesichert...",
  "BACKUP_PROGRESS_BACKUP_CANCELLED": "Datensicherung abgebrochen",
  "BACKUP_PROGRESS_BACKUP_FAILED": "Datensicherung fehlgeschlagen",
  "BACKUP_PROGRESS_BACKUP_SUCCESSFUL": "Datensicherung erfolgreich",
  "BACKUP_PROGRESS_PREFLIGHT": "Verfügbarer Speicherplatz wird geprüft...",
  "BACKUP_PROGRESS_RESTARTING": "Server wird neu gestartet...",
  "BACKUP_PROGRESS_RESTORE_FAILED": "Wiederherstellung fehlgeschlagen",
  "BACKUP_PROGRESS_RESTORE_SUCCESSFUL": "Wiederherstellung erfolgreich",
  "BACKUP_PROGRESS_RESTORING": "Wird wiederhergestellt",
  "BACKUP_PROGRESS_RESTORING_DATA": "Daten werden wiederhergestellt...",
  "BACKUP_PROGRESS_SHUTTING_DOWN": "Server wird heruntergefahren...",
  "BACKUP_PROGRESS_SUMMARY": "Schritt {stepNum} von {totalSteps}",
  "BACKUP_RESTORE_BUTTON": "Von Datensicherungsdatei wiederherstellen...",
  "BACKUP_RESTORE_CONFIRMATION_VERBIAGE": "Datensicherung jetzt wiederherstellen? Bis die Wiederherstellung abgeschlossen ist, ist Portfolio offline. Dies wird Ihre aktuelle Datenbank und Einstellungen überschreiben.",
  "BACKUP_RESTORE_ERROR_MSG_BAD_ARCHIVE": "Das Datensicherungsarchiv ist fehlerhaft. Wählen Sie für die Wiederherstellung eine andere Datensicherung aus.",
  "BACKUP_RESTORE_ERROR_MSG_INSUFFICIENT_SPACE": "Die Datensicherungsdiskette verfügt nicht über ausreichend Speicherplatz\num den Vorgang abzuschließen.\n\n{requiredSpace} erforderlich, {availableSpace} verfügbar.",
  "BACKUP_RESTORE_ERROR_MSG_INVALID_BACKUP_DIRECTORY": "Der aktuell konfigurierte Sicherungspfad ist nicht vorhanden. Der Sicherungspfad wird für das Extrahieren des Archivs verwendet, wenn eine Sicherung wiederhergestellt wird. Bitte setzen Sie die Sicherung auf ein gültiges Verzeichnis zurück.",
  "BACKUP_RESTORE_ERROR_MSG_UNRECOVERABLE_BACKUP": "Bei dem/der Datensicherung ist ein Problem aufgetreten. Siehe Admin-Logs für Einzelheiten.",
  "BACKUP_RESTORE_ERROR_MSG_UNRECOVERABLE_RESTORE": "Bei dem/der Wiederherstellung ist ein Problem aufgetreten. Siehe Admin-Logs für Einzelheiten.",
  "BACKUP_RESTORE_LABEL": "Wiederherstellen",
  "BACKUP_RESTORE_TITLE": "Sichern/Wiederherstellen",
  "BACKUP_RETAIN_LABEL": "Behalten",
  "BACKUP_RETAIN_VALUE": "Nur die {numBackups} jüngsten Datensicherungen behalten",
  "BACKUP_SATURDAY_LABEL": "Samstag",
  "BACKUP_SCHEDULE_LABEL": "Datensicherungsplan erstellen",
  "BACKUP_SCHEDULE_VALUE": "ein",
  "BACKUP_SUNDAY_LABEL": "Sonntag",
  "BACKUP_THURSDAY_LABEL": "Donnerstag",
  "BACKUP_TUESDAY_LABEL": "Dienstag",
  "BACKUP_WEDNESDAY_LABEL": "Mittwoch",
  "BROWSE": "Durchsuchen",
  "BROWSE_FOLDERS_TITLE": "Ordner auf Server durchsuchen",
  "BROWSE_RECENT_FOLDERS_LABEL": "Letzte Ordner",
  "BROWSE_REFRESH": "Artikel synchronisieren",
  "CALL_ATT_BUTTON_BUY_NOW": "Jetzt kaufen",
  "CALL_ATT_BUTTON_SECONDARY": "Setzen Sie sich mit der Verkaufsabteilung für einen Kostenvoranschlag in Verbindung",
  "CALL_ATT_FADEL_BUTTON_MAIN": "Kontakt-Verkäufe zu mehr Information",
  "CALL_ATT_FADEL_MAIN": "Stellen Sie eine angemessene Nutzung Ihrer lizenzierten Inhalte (von Bildern bis hin zu Videos und alles dazwischen) sicher. Portfolio verbindet sich nahtlos mit Rights-Cloud-Software von FADEL, sodass Sie die Nutzungsrechte in Verbindung mit Ihren Assets mühelos sehen und nachvollziehen können, was Ihnen dabei hilft, Engpässe zu beseitigen und die Gefahr kostspieliger Urheberrechtsverletzungen zu reduzieren.",
  "CALL_ATT_FADEL_SUBTITLE": "Kennen Sie Ihre Asset-Nutzungsrechte",
  "CALL_ATT_FADEL_TITLE": "FADEL RIGHTS CLOUD",
  "CALL_ATT_ME_SUBTITLE": "Hochleistungsverarbeitung und Umwandlung",
  "CALL_ATT_ME_MAIN": "Bringen Sie Ihren Portfolio Server an seine Leistungsgrenzen? Mit Media Engine vermeiden Sie Verlangsamungen und verbessern die Gesamtproduktivität, indem die Engpässe, die durch hoch belastete Produktionsumgebungen verursacht werden, eliminieren.\n\n\t• Erhöht die Kapazität und den Datendurchsatz\n\t• Entsperrt zusätzliche Ausgabeformate\n\t• Beschleunigt die Erstellung der Video Vorschau\n\t• Fügen Sie verschiedene Media Engines nach Bedarf hinzu\n\t• Wasserzeichenmarkierung (erfordert NetPublish)",
  "CALL_ATT_ME_BUTTON_MAIN": "Holen Sie sich Media Engine",
  "CALL_ATT_NP_SUBTITLE": "Selbstbedienungsportale für einen sofortigen Zugang zu den Assets",
  "CALL_ATT_NP_MAIN": "Sind Sie diese Anfragen nach Assets in letzter Minute leid? Mit NetPublish ist es einfach Selbstbedienungswebseiten zu posten, bei denen jeder nach Bedarf die Assets von jedem Browser auf jedem Gerät lokalisieren und herunterladen kann.\n\n\t• Seitenerstellung mit einem Klick - kein HTML oder CSS erforderlich\n\t• Mobilgeräte-freundliches, ansprechendes Design\n\t• Flexible Nutzerzugangskontrolle\n\t• Deaktivieren Sie Sites automatisch\n\t• Stellen Sie die Auflösung, die Größe und das Format für den Download ein\n\t• Wasserzeichenmarkierung (erfordert Media Engine)\n\t• Nutzungsberichte",
  "CALL_ATT_NP_BUTTON_MAIN": "Holen Sie sich NetPublish",
  "CALL_ATT_REPORT_TITLE": "Berichterstattung für NetPublish",
  "CALL_ATT_REPORT_SUBTITLE": "RelevanteNutzungseinblicke",
  "CALL_ATT_REPORT_MAIN": "Wollen Sie wissen welche Seiten am aktivsten sind, welche Assets benutzt werden und von wem? Mit NetPublish Berichterstattung bekommen Sie die Einblicke, die Sie brauchen, um Entscheidungen auf der Grundlage der Nutzung des Portfolios Ihres Unternehmens zu treffen.\n\nAufschlüsselung der Nutzung von:\n\t• NetPublish Seitenname\n\t• Nutzername\n\t• Assetname und ID\n\t• Datumund Uhrzeit",
  "CALL_ATT_REPORT_BUTTON_MAIN": "Holen Sie sich NetPublish",
  "CALL_ATT_SK_BUTTON_MAIN": "Versuchen Sie es kostenlos",
  "CALL_ATT_SK_BUTTON_TRY_NOW": "https://extens.is/ykx7",
  "CALL_ATT_SK_MAIN": "Sie suchen einen Weg, Ihren Prozess zu beschleunigen, Schlüsselwörtern Bildern zuzuweisen? Mit Portfolio Smart Keywords können Sie Ihren Bildern mit nur einem Klick automatisch „smart“ Keywords Ihren Bildern zuweisen. Durch Clarifai unterstützt, ein innovatives künstliches Intelligenz Unternehmen, das sich in der visuellen Erkennungstechnologie auszeichnet, eine Liste von Keywordsvorschlägen wird Ihnen in Sekunden geliefert. \n\n\t • Liefert eine Liste von smart keywords in Sekunden \n\t • Spart Zeit und Ressourcen bei der manuellen Keywordsuche \n\t • Etabliert eine konsistente Systematik für Ihre Organisation \n\t • Macht es einfach, Ihre digitalen Bestände schnell zu finden",
  "CALL_ATT_SK_SUBTITLE": "Automatisieren Sie Ihr Bild Keywording",
  "CALL_ATT_SK_TITLE": "Portfolio Smart Keywords",
  "CALL_ATT_SSO_SUBTITLE": "Nahtlose plattformübergreifende Nutzererfahrungen",
  "CALL_ATT_SSO_TITLE": "Einmalige Anmeldung",
  "CALL_ATT_SSO_MAIN": "Haben die Leute in Ihrem Unternehmen Schwierigkeiten, Ihre Anmeldedaten zu behalten? Mit neuen Lösungen geht typischerweise ein Mehraufwand bei der Verwaltung der Nutzerkonten einher, sowohl für Sie als auch für die Nutzer.\n\nGlücklicherweise unterstützt Portfolio die einmalige Anmeldung mit Active Directory. Wenn sie die einmalige Anmeldung nutzen, können die Nutzer sich automatisch von Ihrer Intranetseite in das Portfolio einloggen, wodurch sie eine kontinuierliche Nutzererfahrung haben.\n\n\t• Wird von Windows Server Active Directory unterstützt\n\t• Verbessert die Gesamtsicherheit\n\t• Vereinfacht die Nutzerverwaltung\n\t• Verbessert die Nutzererfahrung",
  "CALL_ATT_SSO_BUTTON_MAIN": "Holen Sie sich Single Sign-On",
  "CALL_ATT_URL_BUY_NOW": "https://secure.portfoliodam.com/portfolio-options?lang=de",
  "CALL_ATT_URL_CONTACT_SALES": "https://portfoliodam.com/de/portfolio/contact-me",
  "canEmbedMetadata": "Eingebettete Metadaten",
  "canImportMetadata": "Daten exportieren/importieren",
  "canManagePublicGallery": "Öffentliche Galerien verwalten",
  "canPublishNetPublishSites": "Kann Veröffentlichen NetPublish Seiten",
  "canSmartKeyword": "Kann Smart Keyword",
  "CANCEL": "Abbrechen",
  "CATALOG": "Katalog",
  "CATALOG_ADD_SELECTED_USERS_TO_CATALOG": "Mitgliedschaft zulassen",
  "CATALOG_BACKUP": "Ausgewählten Katalog sichern",
  "CATALOG_CREATE": "Neuen Katalog hinzufügen",
  "CATALOG_CREATE_AUTOSYNC_DISABLED_INFO_MSG": "Katalogverwalter können vom Desktop Client aus AutoSync-Ordner hinzufügen.",
  "CATALOG_CREATE_AUTOSYNC_FOLDER": "Einen AutoSync-Ordner erstellen",
  "CATALOG_CREATE_CATALOG_TEMPLATE": "Katalogvorlage",
  "CATALOG_TYPE_GENERAL": "Allgemeine Verwendung",
  "CATALOG_TYPE_SIMPLE": "Einfach",
  "CATALOG_CREATE_DATABASES_LIST_LABEL": "Datenbanken",
  "CATALOG_CREATE_ERROR_CREATING_FOLDERS": "Beim Erstellen des {folder}-Ordners trat ein Fehler auf.",
  "CATALOG_CREATE_GLOBAL_SETTING_INFO_MSG": "Standardordner für AutoSync und Vorschaubilder können in den globalen Einstellungen konfiguriert werden.",
  "CATALOG_CREATE_NAME": "Name",
  "CATALOG_CREATE_PREVIEW_DISABLED_INFO_MSG": "Vorschaubilder können in den Katalogdetails konfiguriert werden.",
  "CATALOG_CREATE_PREVIEW_FOLDER": "Für schnelleres Anzeigen die Vorschaubilder speichern",
  "CATALOG_CREATE_SHOW_DATABASES": "Datenbanken anzeigen",
  "CATALOG_CREATE_USE_VERSIONING": "Nutzen Sie die Asset Versionierung",
  "CATALOG_DELETE": "Katalog löschen",
  "CATALOG_DELETE_CONFIRM": "Möchten Sie den ausgewählten Katalog löschen?",
  "CATALOG_DETAILS": "Katalogdetails",
  "CATALOG_DETAILS_CHANGE_NAME_PROMPT": "Zum Umbenennen des Katalogs muss dieser vorübergehend offline genommen werden. Möchten Sie fortfahren?",
  "CATALOG_DETAILS_COLLATION": "Sortierfolge",
  "CATALOG_DETAILS_COLLATION_NA": "—",
  "CATALOG_DETAILS_CREATION_DATE": "Erstellungsdatum",
  "CATALOG_DETAILS_DATABASE_TAB": "Allgemein",
  "CATALOG_DETAILS_LAST_MODIFIED": "Zuletzt geändert am",
  "CATALOG_DETAILS_NUMBER_OF_CONNECTED_USERS": "Verbundene Benutzer",
  "CATALOG_DETAILS_NUMBER_OF_RECORDS": "Datensätze",
  "CATALOG_DETAILS_NUMBER_OF_USERS": "Mitglieder",
  "CATALOG_DETAILS_SIZE_ON_DISK": "Größe auf Festplatte",
  "CATALOG_DETAILS_WARN_DISCONNECT_ADMIN": "Der Administrator-Benutzer wird getrennt. Fortfahren?",
  "CATALOG_DETAILS_LOCKED_FOR_ADMINISTRATION": "Gesperrt für Administration",
  "CATALOG_DETAILS_UNLOCK": "Entsperren",
  "CATALOG_EXPLANATION_VAULT_1": "Vault Kataloge speichern die Assets in einer sicheren Ablage.",
  "CATALOG_EXPLANATION_VAULT_2": "Support-Sperre, Versionseinstellung, Check-Out und Check-In der Vault Kataloge.",
  "CATALOG_EXPLANATION_WF_1": "Watch Ordner Kataloge verfolgen die Assets zurück, die sich in Ihrem Dateisystem befinden.",
  "CATALOG_EXPLANATION_WF_2": "Watch Ordner Kataloge werden von AutoSync. unterstützt.",
  "CATALOG_INGEST_DRAG_HINT_TEXT": "Um dem Upload-Formular Felder hinzuzufügen, ziehen Sie diese aus der Felderliste herüber.",
  "CATALOG_INGEST_FIELDS_FOR_UPLOAD_FORM_LABEL": "Felder für Upload-Formular",
  "CATALOG_INGEST_FIELDS_LABEL": "Felder",
  "CATALOG_INGEST_FORM_HEADER_LABEL": "Formularkopf",
  "CATALOG_INGEST_HEADER_HINT_TEXT": "Der Formularkopf ist optional und erscheint oben auf dem Formular.",
  "CATALOG_INGEST_MAX_FIELDS_WARNING_MESSAGE": "Die maximale Anzahl hinzufügbarer Felder ist {maxFields}.",
  "CATALOG_INGEST_TAB_TITLE": "Verwalteter Upload",
  "CATALOG_INGEST_USE_INGEST_LABEL": "Managed Upload verwenden",
  "CATALOG_INGEST_REQUIRED_LABEL": "Erforderlich",
  "CATALOG_IS_CONNECTED": "Verbunden",
  "CATALOG_IS_DEFAULT": "Standard",
  "CATALOG_MANAGE_USERS": "Katalogmitgliedschaft verwalten",
  "CATALOG_MANAGE_FIELDS": "Katalogfelder verwalten",
  "CATALOG_MANAGE_TEMPLATES_MENU_LABEL": "Katalogvorlagen verwalten...",
  "CATALOG_MANAGE_TEMPLATES_DIALOG_TITLE": "Benutzerdefinierte Katalogvorlagen verwalten",
  "CATALOG_MANAGE_TEMPLATES_DIALOG_HEADER": "Name der Katalogvorlage",
  "CATALOG_MEMBER": "Mitglied",
  "CATALOG_NEW_CATALOG_DETAILS": "Neue Katalogdetails",
  "CATALOG_OFFLINE": "Offline",
  "CATALOG_ONLINE": "Online",
  "CATALOG_OPTIONS_ALL_FILE_TYPES": "Katalog Alle Dateitypen",
  "CATALOG_OPTIONS_CREATE_KEYWORDS_LABEL": "Schlüsselbegriffe von Pfad generieren",
  "CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_FILENAME": "Dateiname",
  "CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_PARENT": "Übergeordneter Ordner",
  "CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_SERVER": "Servername",
  "CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_TREE": "Ordnerhierarchie",
  "CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_VOLUME": "Band",
  "CATALOG_OPTIONS_EXCLUSION_LABEL": "Datei- und Ordnerausschlüsse",
  "CATALOG_OPTIONS_ONLY_FILE_TYPES": "Nur Katalog Catalogar únicamente",
  "CATALOG_OPTIONS_REMOVE_FILE_TYPES_CONFIRMATION": "Ausgewählte(n) Dateityp(en) entfernen?",
  "endsWith": "Endet mit",
  "contains": "Enthält",
  "startsWith": "Beginnt mit",
  "CATALOG_OPTIONS_REMOVE_EXCLUSIONS_CONFIRMATION": "Den/die ausgewählten Ausschlüsse entfernen?",
  "CATALOG_OPTIONS_TAB_TITLE": "Katalogisierungsoptionen",
  "CATALOG_PREVIEWS_DEFAULT_LOCATION_IS": "Der Standardort ist",
  "CATALOG_PREVIEWS_DIMENSIONS_LABEL": "Mindestgröße 300 Pixel, maximale Größe 4000 Pixel (längste Dimension)",
  "CATALOG_PREVIEWS_GENERATE_AUDIO_VIDEO_FILES": "Clips für Audio/Video-Dateien erstellen",
  "CATALOG_PREVIEWS_GENERATE_PREVIEWS": "Vorschaubilder erstellen",
  "CATALOG_PREVIEWS_FOLDER_LOCATION": "Vorschaubilder und Clips in diesem Ordner speichern",
  "CATALOG_PREVIEWS_LOCATION_WARNING_INFO": "Der Server muss auf den Speicherort zugreifen können.",
  "CATALOG_PREVIEWS_MAX_PIXELS": "Maximale Bildgröße",
  "CATALOG_PREVIEWS_MAX_VIDEO_RESOLUTION": "Maximale Video-Auflösung",
  "CATALOG_PREVIEWS_MINUTES": "Minuten",
  "CATALOG_PREVIEWS_PIXELS": "Pixel",
  "CATALOG_PREVIEWS_SHORT": "Vorschaubilder",
  "CATALOG_PREVIEWS_VIDEO_LIMIT_DURATION": "Dauer begrenzen auf:",
  "CATALOG_PREVIEWS_VIDEO_CLIP_PROCESSING_INFO_TEXT": "Das Erstellen von Clips kann eine Weile dauern. \nWenn Sie die Bearbeitungszeit verkürzen möchten, wählen Sie eine niedrigere Auflösung und Dauer.",
  "CATALOG_REMOVE_SELECTED_USERS_FROM_CATALOG": "Mitgliedschaft aufheben",
  "CATALOG_REMOVE_SELECTED_USERS_FROM_CATALOG_CONFIRMATION": "Den Nutzer aus dem Katalog entfernen? \nDie aus diesem Katalog ausgechecktenArtikel werden zurückgegeben und zur Verfügung gestellt.",
  "CATALOG_SAVE_TEMPLATE": "Katalogvorlage speichern...",
  "CATALOG_SAVE_TEMPLATE_DETAILS_TEXT": "Die gespeicherte Katalogvorlage enthält: alle Felder, Metadatenzuordnungen und Katalog-Optionseinstellungen.",
  "CATALOG_SELECT_MESSAGE": "Kein Katalog ausgewählt",
  "CATALOG_SET_AS_DEFAULT": "Standardkatalog festlegen",
  "CATALOG_SK_DEFAULT_SETTINGS": "Standardeinstellungen",
  "CATALOG_SK_CONFIDENCE_LEVEL_LABEL": "Konfidenzniveau",
  "CATALOG_SK_DEFAULT_LABEL": "Empfohlen: {recommended}",
  "CATALOG_SK_ENGINES_LABEL": "Smart Keywords-Engines",
  "CATALOG_SK_LANGUAGES_LABEL": "Sprachen für die General-Engine",
  "CATALOG_SK_NUM_KEYWORDS_LABEL": "Anzahl Suchbegriffe",
  "CATALOG_SK_SETTINGS_LABEL": "Einstellungen",
  "CATALOG_SK_TAB_TITLE": "Smart Keywords",
  "CATALOG_SK_USE_SK_LABEL": "Smart Keywords in diesem Katalog nutzen",
  "CATALOG_STATUS": "Katalogstatus",
  "CATALOG_STORAGE_TYPE_LABEL": "Speichertyp",
  "CATALOG_STORAGE_TYPE_WATCHFOLDERS": "Ordner beobachten",
  "CATALOG_STORAGE_TYPE_VAULT": "Vault",
  "CATALOG_TAKE_OFFLINE_SHORT": "Offline stellen",
  "CATALOG_TAKE_ONLINE_SHORT": "Online stellen",
  "CATALOG_TEMPLATE": "Vorlage",
  "CATALOG_TEMPLATE_NAME": "Vorlagenname",
  "CATALOG_TEMPLATES_TITLE": "Katalogvorlagen",
  "CATALOG_TEMPLATE_REMOVE_CONFIRMATION": "Markierte Katalogvorlage entfernen?",
  "CATALOG_VIEW_DETAILS": "Katalogdetails anzeigen/bearbeiten",
  "CERT_REQUEST_ALREADY_CREATED_WARNING": "Sie haben bereits eine Zertifikatsanforderung gemacht Wenn Sie fortfahren, wird die vorhandene Anforderung gelöscht.",
  "CERTIFICATE_FILE_FILTER": "Zertifikate (p7b, p7, cer, crt, pem, pfx, p12)",
  "CITY_OR_LOCALITY": "Stadt oder Ort",
  "CLEAR_BUTTON_LABEL": "Löschen",
  "COMMUNICATION_AT_INITILIZATION_ERROR": "Bei der Kommunikation mit dem Server ist ein Fehler aufgetreten. Dies wird üblicherweise durch veraltete Daten im Browser-Cache verursacht, könnte aber auch auf ein Problem mit dem Server hinweisen. Wenden Sie sich für weitere Informationen an den Administrator.",
  "CONFIGURE_DIRECTORY_SERVICE": "Verzeichnisdienst konfigurieren",
  "CONFIRM_DELETE_PDL": "Alle vordefinierten Werte für dieses Feld löschen?",
  "CONFIRM_DELETE_SERVICE": "Verzeichnisdienst löschen?\nVom Dienst importierte Benutzer bleiben bestehen. Für deren Passwörter werden zuvor in Portfolio enthaltene Werte wiederhergestellt bzw. deaktiviert (falls zuvor nicht festgelegt).",
  "CONFIRM_TRUNCATE_VALUES": "Die max. Länge überschreitet einen oder mehrere standardmäßige oder vordefinierte Werte für dieses Feld. Werte kürzen?",
  "CONNECTION_REFUSED_ERROR": "Die Verbindung mit dem Verzeichnisservice wurde abgelehnt. Prüfen Sie Hostnamen und Port-Einstellungen.",
  "CONTAINS": "enthält",
  "CONTINUE": "Weiter",
  "CREATE": "Erstellen",
  "CREATE_A_CERTIFICATE_REQUEST": "Zertifikat-Signaturanforderung erstellen",
  "createContactSheet": "PDF erstellen",
  "CREATED_BY": "Erstellt von",
  "CREATE_MAPPING": "Zuweisung Erstellen",
  "CREATE_USER_EXCLUSION_MAPPING": "Benutzer Ausschließen",
  "CREATED_ON_DATE": "Erstellungsdatum",
  "DATE_FORMAT": "DD.MM.YYYY",
  "DATE_FORMAT_ERROR": "Konfigurationsfehler: Falsche Formatierungszeichenfolge.",
  "DATE_INVALID_CHAR_ERROR": "Das Datum enthält ungültige Zeichen.",
  "DATE_TIME_FORMAT": "DD.MM.YYYY L:NN A",
  "DATE_TIME_SECONDS_FORMAT": "DD.MM.YYYY L:NN:SS A",
  "DATE_WRONG_DAY_ERROR": "Geben Sie einen gültigen Tag für den Monat ein.",
  "DATE_WRONG_LENGTH_ERROR": "Geben Sie das Datum in diesem Format ein:",
  "DATE_WRONG_MONTH_ERROR": "Geben Sie einen Monat zwischen 1 und 12 ein",
  "DATE_WRONG_YEAR_ERROR": "Geben Sie ein Jahr zwischen 0 und 9999 ein",
  "DEFAULT_ACCESS_LEVEL": "Standardrolle",
  "DEFAULT_CATALOG": "Standardkatalog",
  "DEFAULT_CATALOG_NONE": "Keine",
  "DEFAULT_PORT_NON_SSL": "Standard-Port für Nicht-SSL:",
  "DEFAULT_PORT_SSL": "Standard-Port für SSL:",
  "DELETE": "Löschen",
  "DELETE_SOURCE": "Quelle Löschen",
  "DELETE_ALL_NESTED_VALUES_CONFIRMATION": "Alle Werte löschen? Dies wird alle Werte löschen, einschließlich verschachtelter Werte.",
  "DELETE_MULTIPLE_NESTED_VALUES_CONFIRMATION": "Den Wert '{value}' löschen?\nEr enthält verschachtelte Werte, die ebenfalls gelöscht werden.",
  "DELETE_NESTED_VALUE_CONFIRMATION": "Die auswählten Werte löschen? Sie enthalten verschachtelte Werte, die ebenfalls gelöscht werden.",
  "DELETE_WARNING_BOX_MSG": "Warnung! Das Löschen kann nicht rückgängig gemacht werden!",
  "DELETE_WARNING_CATALOG_VAULT": "Alle Dateien im Katalog werden zerstört.",
  "DIAGNOSTIC_DATA_TITLE": "Diagnosebericht an Portfolio DAM senden",
  "DIAGNOSTIC_DATA_ACCOUNT_NAME": "Unternehmen oder Kontoname (Erforderlich)",
  "DIAGNOSTIC_DATA_CONTACT_NAME": "Name des Kontakts",
  "DIAGNOSTIC_DATA_TS_TICKET_NUMBER": "Technischer Support Ticket Nummer",
  "DIAGNOSTIC_DATA_SEND_REPORT_BUTTON": "Sende Bericht",
  "DIAGNOSTIC_STATUS_ERROR": "Es gab ein Problem beim Hochladen des Diagnoseberichtes auf {date}",
  "DIAGNOSTIC_STATUS_SENDING": "Senden...",
  "DIAGNOSTIC_STATUS_SUCCESS": "Der Diagnosebericht wurde erfolgreich an Portfolio DAM auf {date} gesandt",
  "DIRECTORY_SERVICE_CONNECT_ERROR": "Die Verbindung mit dem Verzeichnisservice konnte nicht hergestellt werden. Prüfen Sie Hostnamen und Port-Einstellungen.",
  "DIRECTORY_SERVICES": "Verzeichnisdienst",
  "DIRECTORY_USERS_CANNOT_BE_DELETED": "Benutzer des Verzeichnisdienstes können nicht gelöscht werden.",
  "DISTRIBUTION_GROUPS": "Distributionsgruppen",
  "DOWNLOAD_CERT_PROMPT": "Zertifikatanforderungsdatei herunterladen?",
  "DOWNLOAD_COMPLETE_STRING": "Download abgeschlossen.",
  "downloadPreviews": "Vorschaubilder herunterladen",
  "EMAIL_ADDRESS": "E-Mail-Adresse",
  "EMAIL_CONFIG_AUTH_PASSWORD": "Kennwort",
  "EMAIL_CONFIG_AUTH_USERNAME": "Benutzername",
  "EMAIL_CONFIG_ENABLED": "E-Mail-Feedback aktivieren",
  "EMAIL_CONFIG_FROM_ADDRESS": "E-Mail von Adresse",
  "EMAIL_CONFIG_INVALID_GENERIC": "E-Mail Server-Konfiguration ist ungültig",
  "EMAIL_CONFIG_INVALID_SERVER_NOT_FOUND": "E-Mail Server nicht gefunden",
  "EMAIL_CONFIG_INVALID_AUTHENTICATION_FAILED": "E-Mail Server Authentifizierung fehlgeschlagen",
  "EMAIL_CONFIG_MESSAGE": "Jeder Benutzer, der Benachrichtigungen erhalten möchte, muss im Benutzerbereich eine E-Mail-Adresse zugeordnet bekommen.",
  "EMAIL_CONFIG_SERVER_ADDRESS": "SMTP Server Adresse",
  "EMAIL_CONFIG_SERVER_PORT": "SMTP Server Port",
  "EMAIL_CONFIG_SUCCESS_MESSAGE": "SMTP Server verifiziert",
  "EMAIL_CONFIG_USE_SSL_TLS": "Verwende SSL / TLS",
  "EMAIL_CONFIG_USE_SMTP_AUTH": "Verwende SMTP Authentifizierung",
  "EMAIL_CONFIG_VALIDATE": "Verbindung testen",
  "EMAIL_CONFIG_VALIDATED": "E-Mail Server verifiziert",
  "english": "Englisch",
  "ENTIRE_TREE_UNDER_SEARCH_BASE": "Gesamter Verzeichnisbaum unter Suchbasis",
  "EQUALS": "ist gleich",
  "EXPORT_MENU_STRING": "Werte exportieren",
  "FADEL_HOWTO": "LOGON zu Ihrem FADEL Konto:",
  "FALSE_LABEL": "Falsch",
  "FAULT_MSG_ADMIN_SERVICE_CREATION_ERROR": "Stellen Sie sicher, dass der Admin-Server auf dem lokalen Rechner läuft und den auf der Port-Seite angegebenen Port verwendet. Sollte dies nicht der Fall sein, muss der Server erneut gestartet und diese Anwendung noch einmal geladen werden.",
  "FAULT_MSG_BACKUP_RESTORE_IN_PROGRESS": "Während ein Datensicherungs- oder -wiederherstellungsprozess läuft, kann dieser Vorgang nicht durchgeführt werden.",
  "FAULT_MSG_CATALOG_IS_IN_ADMIN_MODE": "Bei diesem Vorgang ist ein Fehler aufgetreten, da sich der Katalog im Verwaltungsmodus befindet.",
  "FAULT_MSG_CREATE_CATALOG_DUPLICATE_NAME": "Ein Katalog mit diesem Namen ist bereits vorhanden.",
  "FAULT_MSG_CREATE_USER_DUPLICATE_ACCOUNT_NAME": "Ein Benutzer mit diesem Kontonamen ist bereits vorhanden.",
  "FAULT_MSG_DB_IN_USE": "Der Vorgang konnte nicht abgeschlossen werden, da der Katalog derzeit von einem Administrator verwendet wird.",
  "FAULT_MSG_DELETE_ADMIN": "Sie können das Administratorkonto nicht löschen.",
  "FAULT_MSG_DELETE_SELF": "Sie können Ihr Benutzerkonto nicht löschen.",
  "FAULT_MSG_DELETE_CATALOG_TEMPLATE_ERROR": "Während des Löschens der Katalogvorlage ist ein unerwarteter Fehler aufgetreten.",
  "FAULT_MSG_DUPE_NAME": "Ein Objekt mit diesem Namen ist bereits vorhanden. Bitte geben Sie einen anderen Namen ein.",
  "FAULT_MSG_DUPLICATE_MEDIA_ENGINE_ADDRESS": "Eine Media Engine mit dieser Adresse und diesem Port ist bereits vorhanden.",
  "FAULT_MSG_ENTITY_VERSION_MISMATCH": " Bei diesem Vorgang ist ein Fehler aufgetreten, da die Kundendaten nicht mehr aktuell sind.",
  "FAULT_MSG_IDENT_SERVICE_CREATION_ERROR": "Stellen Sie sicher, dass der Server auf dem lokalen Rechner läuft und den auf der Port-Seite angegebenen Port verwendet. Sollte dies nicht der Fall sein, muss der Server erneut gestartet und die Anwendung noch einmal geladen werden.",
  "FAULT_MSG_INVALID_SESSION_ID": "Ihre Sitzung ist abgelaufen. Sie müssen sich erneut beim Server anmelden.",
  "FAULT_MSG_IS_NOT_LICENSED": "Für diesen Vorgang besitzt der Server keine Lizenz.",
  "FAULT_MSG_LEGACY_21000": "Dieser Vorgang ist aufgrund eines unbekannten internen Fehlers fehlgeschlagen.",
  "FAULT_MSG_LOGGING_ERR_UPDATE": "Bei der Aktualisierung der Protokoll-Konfiguration ist ein Fehler aufgetreten",
  "FAULT_MSG_LOG_DIR_NOT_VALID": "Das angegebene Log-Verzeichnis existiert nicht, das Schreiben in diesem Verzeichnis ist nicht möglich oder der Pfad ist kein Verzeichnis.",
  "FAULT_MSG_NO_DIRECTORY": "Der angegebene Ort ist nicht vorhanden bzw. ist kein Verzeichnis.",
  "FAULT_MSG_NULL_DESCRIPTION": "Ein unerwarteter Fehler ist aufgetreten; eine Beschreibung ist jedoch nicht vorhanden.",
  "FAULT_MSG_NULL_FAULTEVENT": "Ein unerwarteter Fehler ist aufgetreten; Details sind jedoch nicht vorhanden.",
  "FAULT_MSG_OPERATION_INSUFFICIENT_PRIVILEGES": "Bei diesem Vorgang ist ein Fehler aufgetreten, da Sie unzureichende Berechtigungen haben.",
  "FAULT_MSG_OPERATION_IS_INVALID": "Dieser Vorgang war ungültig.",
  "FAULT_MSG_RENAME_CATALOG_TEMPLATE_ERROR": "Während der Umbenennung der Katalogvorlage ist ein unerwarteter Fehler aufgetreten.",
  "FAULT_MSG_SAVE_CATALOG_TEMPLATE_ERROR": "Während der Speicherung der Katalogvorlage ist ein unerwarteter Fehler aufgetreten.",
  "FAULT_MSG_SERVER_NOT_RUNNING": "Der Server läuft nicht.",
  "FAULT_MSG_ENTERPRISE_NOT_LICENSED": "Bei diesem Vorgang trat ein Fehler auf, da der Server keine Enterprise Modul-Lizenz besitzt.",
  "FAULT_MSG_REMOVE_METADATA_DEF": "Die Metadaten-Definition konnte nicht entfernt werden. Möglicherweise wird sie von anderen Katalogen genutzt.",
  "FAULT_MSG_UNHANDLED_PORTFOLIO_FAULT": "Der Server hat einen Fehler mit der folgenden Meldung ausgegeben: ",
  "FAULT_MSG_UNHANDLED_PORTFOLIO_FAULT_WITHOUT_MESSAGE": "Der Server hat einen Fehler ohne Fehlermeldung ausgegeben. ",
  "FAULT_MSG_UNHANDLED_UNKNOWN_FAULT": "Der Server hat einen Fehler unbekannter Art mit der folgenden Meldung ausgegeben:",
  "FAULT_MSG_UNKNOWN_SMTP_SERVER": "Verbindung mit dem angegebenen E-Mail Server nicht möglich.",
  "FAULT_MSG_WINDOWS_SERVICE_IS_NOT_RUNNING": "Bei diesem Vorgang ist ein Fehler aufgetreten, da sich ein Dienst nicht im erwarteten Zustand befand.",
  "FAULT_MSG_INVALID_LOGINID_OR_PASSWORD": "Benutzername oder Passwort ist für diese Datenbank ungültig.",
  "FAULT_MSG_BAD_DB_PORT": "Angegebener Datenbank-Anschluss ist ungültig.",
  "FAULT_MSG_BAD_DB_HOST": "Angegebener Datenbank-Hostname oder Anschluss ist ungültig.",
  "FIELD_ACTION_ADD": "Neues benutzerdefiniertes Feld hinzufügen",
  "FIELD_ACTION_DELETE": "Markiertes Feld löschen",
  "FIELD_ACTION_MANAGE_CUSTOM_XMP_NAMESPACES": "XMP-Namespaces",
  "FIELD_ACTION_MANAGE_METADATA": "Metadaten verwalten",
  "FIELD_CATEGORY_CUSTOM": "Benutzerdefinierte Felder",
  "FIELD_CATEGORY_SYSTEM": "Systemfelder",
  "FIELD_CATEGORY_EXIF": "EXIF",
  "FIELD_CATEGORY_IPTC": "IPTC",
  "FIELD_CATEGORY_XMP": "XMP",
  "FIELD_CATEGORY_MOVIE": "Film",
  "FIELD_CATEGORY_OFFICE": "MS Office",
  "FIELD_CATEGORY_GEO": "GEO",
  "FIELD_CATEGORY_LABEL": "Feldkategorie",
  "FIELD_DISABLE_CONFIRM_MSG": "Möchten Sie das ausgewählte Feld deaktivieren?",
  "FIELD_ENABLE_ALL_CATEGORIES_LABEL": "Alle aktivieren",
  "FIELD_FORM_LABEL_ADD_EXTRACT_MAPPING": "Extraktionszuordnung hinzufügen",
  "FIELD_FORM_LABEL_DEFAULT_VALUE": "Standardwert",
  "FIELD_FORM_LABEL_DISABLED": "(Deaktiviert)",
  "FIELD_FORM_LABEL_EMBED": "In Metadaten einbetten",
  "FIELD_FORM_LABEL_EXTRACT": "Aus Metadaten extrahieren",
  "FIELD_FORM_LABEL_FIELD_NAME": "Feldname",
  "FIELD_FORM_LABEL_FIELD_TYPE": "Feldtyp",
  "FIELD_FORM_LABEL_HAS_MULTIPLE_VALUES": "Mehrere Werte zulassen",
  "FIELD_FORM_LABEL_HAS_PREDEFINED_VALUES": "Hat vordefinierte Werte",
  "FIELD_FORM_LABEL_HELP_TEXT": "Hilfetext",
  "FIELD_FORM_LABEL_MAX": "Max: {max}",
  "FIELD_FORM_LABEL_MAX_LENGTH": "Max. Länge",
  "FIELD_FORM_LABEL_METADATA_TAG": "Metadaten-Name",
  "FIELD_FORM_LABEL_METADATA_TYPE": "Metadaten-Typ",
  "FIELD_FORM_LABEL_ONLY_PREDEFINED_VALUES": "Nur vordefinierte Werte zulassen",
  "FIELD_FORM_LABEL_PRECISION": "Präzision",
  "FIELD_FORM_LABEL_PREDEFINED_VALUES": "Vordefinierte Werte",
  "FIELD_FORM_LABEL_SHOW_TIME": "Showtime",
  "FIELD_FORM_LABEL_USE_METADATA": "Metadaten extrahieren und einbetten",
  "FIELD_FORM_WARNING_DUPE_EMBEDS": "Warnung: Es wird mehr als ein Feld in '{metadata}' eingebettet",
  "FIELD_METADATA_DATA_TYPE_LABEL": "Datentyp",
  "FIELD_METADATA_DEFINITION_IS_CUSTOM": "Ist benutzerdefiniert",
  "FIELD_METADATA_DEFINITIONS_TITLE": "Metadaten-Definitionen",
  "FIELD_METADATA_DELETE_CONFIRM_MSG": "Bestätigen: Metadaten-Definition löschen?",
  "FIELD_METADATA_MULTIVALUED_TYPE_LABEL": "Mehrwertiger Typ",
  "FIELD_METADATA_MULTIVALUED_TYPE_NOT_MULTIVALUED_LABEL": "Nicht mehrwertig",
  "FIELD_METADATA_MULTIVALUED_TYPE_ORDERED_LABEL": "Geordnet",
  "FIELD_METADATA_MULTIVALUED_TYPE_UNORDERED_LABEL": "Ungeordnet",
  "FIELD_METADATA_NAME_LABEL": "Name",
  "FIELD_METADATA_NAMESPACE_LABEL": "Namespace",
  "FIELD_METADATA_NEW_NAMESPACE_TOOLTIP": "Einen benutzerdefinierten XMP-Namespace hinzufügen...",
  "FIELD_METADATA_TAG_LABEL": "Tag",
  "FIELD_METADATA_TYPE_LABEL": "Typ",
  "FIELD_MULTIPLE_FIELDS_SELECTED_MESSAGE": "Mehrere Felder ausgewählt",
  "FIELD_NAMESPACE_ABBREVIATION": "Abkürzung",
  "FIELD_NAMESPACE_REMOVE_CONFIRMATION": "Benutzerdefinierten XMP-Namespace löschen?\nMöglicherweise nutzen Felddefinitionen den Namespace.",
  "FIELD_NAMESPACE_URI": "Namespace URI",
  "FIELD_NEW_FIELD_NAME": "Neues Feld",
  "FIELD_NEW_METADATA_TITLE": "Neue Metadaten-Definition",
  "FIELD_NEW_NAMESPACE_TITLE": "Neuer benutzerdefinierter XMP-Namespace",
  "FIELD_NO_FIELD_SELECTED_MESSAGE": "Kein Feld ausgewählt",
  "FIELD_PAGE_TITLE": "Feder für Katalog '{catalogName}' verwalten",
  "FIELD_REVERT_CONFIRM_MSG": "Bestätigen: Feld wiederherstellen?",
  "FIELD_TYPE_BLOB": "Blob",
  "FIELD_TYPE_BOOLEAN": "Boolesch",
  "FIELD_TYPE_DATETIME": "Datum/Uhrzeit",
  "FIELD_TYPE_DECIMAL": "Dezimal",
  "FIELD_TYPE_LANG_ALT": "Lang Alt",
  "FIELD_TYPE_NUMBER": "Zahl",
  "FIELD_TYPE_PICTURE": "Bild",
  "FIELD_TYPE_STRING": "String",
  "FIELD_TYPE_STRUCTURE": "Struktur",
  "FIELD_TYPE_TEXTBLOCK": "Textblock",
  "FIELD_TYPE_UNKNOWN": "Unbekannt",
  "FIELD_TYPE_URL": "URL",
  "FILE_IO_ERROR_MSG": "Beim Hochladen der Datei auf den Server trat ein Fehler auf.",
  "FILE_WRONG_TYPE_ERROR_MSG": "Dieser Dateityp wird nicht unterstützt. \n Bitte wählen Sie eine jpeg-, gif- oder png-Datei.",
  "FOLDER_PATH_AUTOSYNC_FILES_STRING": "Dateien",
  "FOLDER_PATH_ALREADY_EXIST_AS_FILE": "Eine Datei mit diesem Namen ist vorhanden.",
  "FOLDER_PATH_DOES_NOT_EXIST": "Pfad ist nicht vorhanden.",
  "FOLDER_PATH_ERROR": "Fehler",
  "FOLDER_PATH_NOT_VERIFIED": "Der Ordnerpfad wurde nicht geprüft.",
  "FOLDER_PATH_PATH": "Pfad",
  "FOLDER_PATH_OPERATION_INVALID": "Ein ungültiger Vorgang",
  "FOLDER_PATH_SUCCESS": "Erfolg",
  "FOLDER_PATH_TYPE_AUTOSYNC": "AutoSync",
  "FOLDER_PATH_TYPE_PREVIEW": "Vorschau",
  "FOLDER_PATH_UNKNOWN_FAULT": "Ein unbekannter Fehler",
  "french": "Französisch",
  "FULL_NAME": "Voller Name",
  "FULLY_QUALIFIED_DOMAIN_NAME": "Vollständig qualifizierter Domainname",
  "german": "Deutsch",
  "GLOBAL_SETTINGS_AUTOSYNC_PATH_LABEL": "AutoSync-Ordner für neue Kataloge in diesem Ordner erstellen",
  "GLOBAL_SETTINGS_BACKGROUND_COLOR": "Hintergrundfarbe",
  "GLOBAL_SETTINGS_BACKGROUND_COLOR_TOOLTIP": "Hintergrundfarbe der Login-Maske.",
  "GLOBAL_SETTINGS_CATALOG_DEFAULTS": "Katalogstandardeinstellung",
  "GLOBAL_SETTINGS_CHOOSE_FILE": "Datei auswählen",
  "GLOBAL_SETTINGS_CUSTOM_IMAGE": "Eigenes Bild",
  "GLOBAL_SETTINGS_CUSTOM_IMAGE_INFO_TEXT": "Die ungefähre Größe sollte maximal 2400 x 1350 Pixel betragen.",
  "GLOBAL_SETTINGS_CUSTOM_TITLE": "Eigener Titel",
  "GLOBAL_SETTINGS_CUSTOM_TITLE_TOOLTIP": "Der Titel, der auf Reitern oder in Lesezeichen im Browser angezeigt wird.",
  "GLOBAL_SETTINGS_CUSTOMIZED_LOGIN_SCREEN": "Angepasste Login-Maske",
  "GLOBAL_SETTINGS_DEFAULT_ACCESS_LABEL": "Standardrolle",
  "GLOBAL_SETTINGS_DEFAULT_LOGIN_SCREEN": "Standard-Login-Maske",
  "GLOBAL_SETTINGS_EMAIL_CONFIGURATION": "E-Mail Benachrichtigung",
  "GLOBAL_SETTINGS_FADEL": "FADEL Rights Cloud",
  "GLOBAL_SETTINGS_FOLDERS_ACCESSIBLE_INFO_MSG": "Der Speicherort der AutoSync- und Vorschauordner muss vom Server aus zugänglich sein.",
  "GLOBAL_SETTINGS_IMAGE_URL": "Link",
  "GLOBAL_SETTINGS_IMAGE_URL_TOOLTIP": "Der Klick auf das Bild öffnet diesen URL in einem neuen Browser-Fenster.",
  "GLOBAL_SETTINGS_NOT_LOGGED_IN_INFO_MSG": "Um Änderungen vorzunehmen, starten Sie den Server oder suchen Sie nach einer abgelaufenen Serverlizenz.",
  "GLOBAL_SETTINGS_PREVIEW_PATH_LABEL": "Vorschaubilder für neue Kataloge in diesem Ordner speichern",
  "GLOBAL_SETTINGS_SERVER_DATA_LOCATIONS": "Serverdatenorte",
  "GLOBAL_SETTINGS_WEB_CLIENT_CUSTOMIZATION": "Portfolio LOGON-Kundenbezogenheit",
  "GLOBAL_SETTINGS_SSO_CREDENTIALS": "Einmalige Anmeldedaten (SSO)",
  "GLOBAL_SETTINGS_USER_ACCOUNT_TOOLTIP": "Geben Sie das Benutzerkonto ein, das mit dem Portfolio Serverdienst für die Kerberos-Authentifizierung verknüpft ist.",
  "GLOBAL_SETTINGS_WORK_DIRECTORY_LABEL": "Temporärer Arbeitsordner:",
  "GLOBAL_SETTINGS_WORK_DIRECTORY_CHANGED_MSG": "Der Arbeitsordner wird beim nächsten Starten des Servers geändert. Der neue Ordner wird sich hier befinden: ",
  "GLOBAL_SETTINGS_WORK_DIRECTORY_REQUIRES_RESTART_MSG": "Für diese Änderung müssen Sie den Server erneut starten.",
  "GLOBAL_SETTINGS_VAULT_CONFIGURATION": "Portfolio Vault-Konfiguration:",
  "GLOBAL_SETTINGS_VAULT_DIRECTORY_LABEL": "Portfolio Vault-Ordner:",
  "SERVER_DATA_DEFAULT_VAULT_LOCATION_IS": "Standardmäßiger Portfolio-Vault-Speicherort:",
  "GLOBAL_SETTINGS_VAULT_SERVER_RUNNING_MESSAGE": "Um Portfolio Vault zu verschieben, müssen Sie zuerst den Server herunterfahren.",
  "HELP_URL": "https://helpdocs.portfoliodam.com/de/portfolio/administration/{version}/index.htm",
  "HELP_URL_FADEL": "https://helpdocs.portfoliodam.com/portfolio/{version}/administration/de/Content/03_Catalogs/05_FADEL.htm",
  "HOSTNAME": "Hostname",
  "IDENTITY_SERVICE_DEFAULT_ROLE_STRING": "(Standard)",
  "IDENTITY_SERVICE_SUCCESSFUL_CREATION": "Directory Service-Verbindung erfolgreich. Konfiguration gespeichert.",
  "IMAGE_FILE_FILTER": "Bilder (jpg, gif, png)",
  "IMPORT_LDAP": "Benutzer aus LDAP/AD-Server importieren",
  "IMPORT_LDAP_SPECIFY_SERVER": "LDAP/AD-Server angeben",
  "IMPORT_MENU_STRING": "Werte importieren",
  "IMPORT_SOURCE": "Quelle importieren",
  "INVALID_DN_SYNTAX_ERROR": "Die Verbindung mit dem Verzeichnisservice konnte aufgrund eines ungültigen DN-Syntaxfehlers nicht hergestellt werden. Prüfen Sie den Benutzernamen.",
  "japanese": "Japanisch",
  "LAST_CERTIFICATE_REQUEST_LABEL": "Letzte Zertifikatsanforderung",
  "LAST_MODIFIED_BY": "Zuletzt geändert von",
  "LAST_MODIFIED_DATE": "Datum der letzten Änderung",
  "LDAP_ADDRESS": "LDAP/AD-Serveradresse",
  "LDAP_BIND_USERNAME": "LDAP-Verbindung-Benutzername",
  "LDAP_SYNC_NOTIFICATION": "Synch-Anforderung beim Server eingegangen.",
  "LIC_ADD_MESSAGE": "Kopieren Sie die Lizenzen und fügen Sie sie ein, oder tragen Sie diese einzeln pro Zeile ein.",
  "LIC_ADD_SN": "Neue Lizenz hinzufügen",
  "LIC_ADD_SN_SHORT": "Fügen Sie Lizenzen hinzu",
  "LIC_ASSET_CAP_DISPLAY": "Assets",
  "LIC_DAYS_REMAINING": "({days} verbleibende Tage)",
  "LIC_DEMO_PERIOD": "Demozeitraum",
  "LIC_ERROR_MSG": "Ungültige Seriennummer, bitte wiederholen Sie die Eingabe. Wenn das Problem weiterhin bestehen sollte, überprüfen Sie Ihr Serverprotokoll oder wenden Sie sich an Ihren Administrator.",
  "LIC_NOT_COMPATIBLE_WITH_LITE_ERROR_MSG": "Die Seriennummer kann dem Portfolio Studio nicht hinzugefügt werden.",
  "LITE_CANNOT_CREATE_FDB_CATALOG": "Ihre Portfolio-Lizenz lässt nur einen Katalog zu. Bitte nehmen Sie ein Upgrade Ihrer Portfolio-Lizenz vor, um diesen Vorgang auszuführen.",
  "LITE_CANNOT_SERVE_FDB_CATALOG": "Das Online-Stellen weiterer Kataloge ist mit Ihrer Portfolio Server-Lizenz nicht gestattet.",
  "LITE_THIS_FEATURE_NOT_SUPPORTED": "Die Portfolio Server-Lizenz unterstützt diesen Vorgang nicht.",
  "LOGGING_CONFIGURATION": "Protokollkonfiguration",
  "LOGGING_CONFIGURATION_SERVER_RUNNING_MESSAGE": "Wenn Sie den Speicherort des Protokolls ändern möchten, fahren Sie zuerst den Portfolio Server herunter.",
  "LOGGING_DEFAULT_LOCATION_MSG": "Stardard-Protokollspeicherort ist",
  "LOGGING_DIR_MUST_EXIST": "HINWEIS: Um das Log-Verzeichnis ändern zu können, muss das neu angegebene Verzeichnis bereits existieren und der Benutzer, der Portfolio Server ausführt, muss darin schreiben können.",
  "LOGGING_LOG_DIR": "Protokollverzeichnis:",
  "LOGGING_LOG_LEVEL": "Protokollebene",
  "LOGGING_NUM_LOGS_TO_RETAIN": "Anzahl der aufzubewahrenden Protokolle",
  "LOGIN": "Login",
  "MAPPING_HEADER": "Benutzer/Gruppenmappings zu Portfolio",
  "MAPPINGS_HAVE_BEEN_MODIFIED_ALERT": "Die Zuweisungen wurden geändert; sollen sie gespeichert werden?",
  "MEDIA_ENGINES_ACTION_ADD": "Neue Media Engine hinzufügen",
  "MEDIA_ENGINES_ACTION_DELETE": "Media Engine löschen",
  "MEDIA_ENGINES_ACTION_EDIT": "Media Engine-Details anzeigen/bearbeiten",
  "MEDIA_ENGINES_CANT_ACTIVATE_NO_LICENSE": "Eine weitere Active Media Engine kann nicht hinzugefügt werden, da der Server bereits die von Ihrer Portfolio Media Engine Lizenz zugelassene Höchstanzahl der Active Media Engines verwendet.",
  "MEDIA_ENGINES_CANT_ADD_NO_LICENSES": "Sie können keine Media Engine hinzufügen, da dem Server keine Lizenz für Portfolio Media Engine zur Verfügung steht.",
  "MEDIA_ENGINES_CANT_REMOVE_BUILT_IN_SERVER": "Die eingebaute Media Engine kann nicht entfernt werden.",
  "MEDIA_ENGINES_COLUMN_ACTIVE": "Aktiv",
  "MEDIA_ENGINES_COLUMN_ADDRESS": "Adresse",
  "MEDIA_ENGINES_COLUMN_PORT": "Port",
  "MEDIA_ENGINES_CONFIRM_DELETE": "Möchten Sie die ausgewählte Media Engine löschen?",
  "MEDIA_ENGINES_EDIT_DETAILS_HEADER": "Media Engine-Details",
  "MEDIA_ENGINES_LICENSES_LABEL": "Media Engine-Plätze für Aktivierung verfügbar",
  "MEDIA_ENGINES_NEW_DETAILS_HEADER": "Neue Media Engine-Details",
  "MEDIA_ENGINES_WARN_NO_ENGINES_ARE_ACTIVE": "Media Engines sind nicht aktiv. Sie sollten eine Media Engine aktivieren, bevor die Kunden die Portfolio Media-Dienste verwenden müssen.",
  "MOBILE": "Mobil",
  "MOBILE_ENABLED": "Mobile Uploads erlauben",
  "MOBILE_FOLDER_VERBIAGE": "Mobile Uploads in diesem Ordner speichern.",
  "MOBILE_CREATE_CATALOG_VERBIAGE": "Neuen Katalog 'Mobile Uploads' anlegen, um diesen Ordner automatisch zu überwachen (empfohlen) ",
  "MOBILE_CATALOG_NAME": "Mobile Uploads",
  "modifyAssetContents": "Überprüfen Sie heraus Anlagegüter",
  "MODIFY_LDAP": "LDAP-Abfrage ändern",
  "NAME": "Name",
  "NAME_TOO_LONG_ERROR": "Der Name muss weniger als 256 Zeichen aufweisen",
  "NAV_ABOUT": "Über",
  "NAV_ACCESS_LEVELS": "Rollen",
  "NAV_AUTOSYNC": "Autosync",
  "NAV_BACKUPS": "Sichern/Wiederherstellen",
  "NAV_CATALOGS": "Kataloge",
  "NAV_GLOBAL_SETTINGS": "Globale Einstellungen",
  "NAV_HELP": "Hilfe",
  "NAV_LICENSES": "Lizenzen",
  "NAV_LOGOUT": "Abmelden",
  "NAV_MEDIA_ENGINES": "Media Engines",
  "NAV_NETPUBLISH_SETTINGS": "NetPublish",
  "NAV_PORTS": "Ports",
  "NAV_REPORTING": "Reports",
  "NAV_SETTINGS": "Einstellungen",
  "NAV_STATUS": "Status",
  "NAV_USERS": "Benutzer",
  "NO_CATALOGS": "Keine",
  "NO_FILE_SELECTED": "Keine Datei ausgewählt",
  "VaultFolderNotFound": "Der Portfolio Vault-Ordner wurde nicht unter {path} gefunden.",
  "NO_VAULT_FOLDER": "Der Portfolio Vault-Ordner wurde nicht unter {path} gefunden. Bitte überprüfen Sie den Ort des Ordners in Ihrem Dateisystem und unter den Globale Einstellung -> Server Datenseite dieser Anwendung.",
  "NOTES": "Hinweise",
  "NUMBER_DECIMAL_POINT_COUNT_ERROR": "Das Dezimaltrennzeichen kann nur einmal vorhanden sein.",
  "NUMBER_EXCEEDS_MAX_ERROR": "Die eingegebene Zahl ist zu groß.",
  "NUMBER_INTEGER_ERROR": "Die Zahl muss eine Ganzzahl sein.",
  "NUMBER_INVALID_CHAR_ERROR": "Die Eingabe enthält ungültige Zeichen.",
  "NUMBER_INVALID_FORMAT_CHARS_ERROR": "Einer der Formatierungsparameter ist ungültig.",
  "NUMBER_LOWER_THAN_MIN_ERROR": "Der eingegebene Betrag ist zu klein.",
  "NUMBER_NEGATIVE_ERROR": "Der Betrag kann nicht negativ sein.",
  "NUMBER_PRECISION_ERROR": "Der eingegebene Betrag enthält zu viele Stellen hinter dem Dezimalkomma.",
  "NUMBER_SEPARATION_ERROR": "Dem Tausender-Trennzeichen müssen drei Stellen folgen.",
  "OK": "OK",
  "ON_DATE": "ein",
  "OPEN_DIRECTORY": "Open Directory",
  "OPEN_DIRECTORY_GROUPS": "Gruppen",
  "ORGANIZATION_NAME": "Organisationsbezeichnung",
  "ORGANIZATIONAL_UNIT": "Organisatorische Einheit",
  "PASSWORD": "Kennwort",
  "PASSWORD_CONFIRM": "Kennwort bestätigen",
  "PASSWORD_TOO_LONG_ERROR": "Das Kennwort muss weniger als 256 Zeichen aufweisen",
  "PORT": "Port",
  "PORT_VALUE_TOO_HIGH_ERROR": "Der Port-Wert muss kleiner als 65536 sein.",
  "PortfolioAssetCap": "Portfolio Asset Cap",
  "PortfolioAPI": "Portfolio API",
  "PortfolioDemo": "Demo",
  "PortfolioDirServices": "Portfolio Directory Services",
  "PortfolioServer": "Portfolio-Server",
  "PortfolioStudio": "Portfolio Studio Edition",
  "PortfolioProfessional": "Portfolio Professional Edition",
  "PortfolioEnterprise": "Portfolio Enterprise Edition",
  "PortfolioMediaEngine": "Portfolio Media Engine",
  "NetPublish": "Portfolio NetPublish",
  "PortfolioMobile": "Portfolio Flow",
  "PortfolioSmartKeywords": "Portfolio Smart Keywords",
  "PortfolioUserConnection": "Portfolio-Benutzerverbindung",
  "PortfolioSingleSignOn": "Single-Sign-On (SSO)",
  "PORT_CURRENT_VALUE": "Aktueller Wert",
  "PORT_ERROR_MSG_BAD_PORT_VALUE": "Der neue Port-Wert muss eine Zahl zwischen 1 und 65535 sein.",
  "PORT_ERROR_MSG_CONFLICT": "Die Port-Werte können nicht aktualisiert werden, da einer dieser neuen Werte bereits vom Server verwendet wird.",
  "PORT_FIND_PORT": "Port suchen",
  "PORT_NAME": "Name",
  "PORT_NEW_VALUE": "Neuer Wert",
  "PORT_RESTART_NOTICE": "Hinweis: Port-Aktualisierungen treten erst nach dem erneuten Starten des Servers in Kraft.",
  "PORT_RESTART_SERVER": "Server neu starten",
  "PORT_UPDATE_PORTS": "Ports aktualisieren",
  "PORT_WARNING_ADMIN_RESTART": "Der Admin-Port wurde geändert. Der Browser wird in {numSecs} Sekunden zur neuen Adresse weitergeleitet.",
  "PREVIEW_MAX_VIDEO_RESOLUTION_360": "360p",
  "PREVIEW_MAX_VIDEO_RESOLUTION_480": "480p",
  "PREVIEW_MAX_VIDEO_RESOLUTION_540": "540p HD",
  "PREVIEW_MAX_VIDEO_RESOLUTION_720": "720p HD",
  "PREVIEW_MAX_VIDEO_RESOLUTION_1080": "1080p HD",
  "PROMPT_ARE_YOU_SURE": "Sind Sie sicher?",
  "PROMPT_COULD_NOT_CREATE_FOLDER": "Dieser Ordner konnte nicht erstellt werden. Geben Sie einen anderen Pfad ein.",
  "PROMPT_COULD_NOT_CREATE_FOLDERS": "Geben Sie einen anderen Ordnerpfad ein, da die folgenden Pfade nicht erstellt werden konnten:",
  "PROMPT_COULD_NOT_CREATE_FOLDER_FILE_CONFLICT": "Dieser Ordner konnte nicht erstellt werden, da bereits eine Datei mit diesem Namen vorhanden ist. Geben Sie einen anderen Pfad ein.",
  "PROMPT_CREATE_THAT_FOLDER": "Dieser Ordner ist nicht vorhanden. Möchten Sie ihn erstellen?",
  "PROMPT_CREATE_THESE_FOLDERS": "Diese Ordner sind nicht vorhanden. Möchten Sie sie erstellen?",
  "PROMPT_DELETE_LICENSE_CONFIRM": "Möchten Sie die ausgewählte Lizenz löschen?",
  "QUERY": "Anfrage",
  "REMOVE": "Entfernen",
  "REMOVE_DIRECTORY_SERVICE": "Verzeichnisdienst entfernen",
  "REPLACE_USER_MAPPING_CONFIRMATION": "Für diesen Benutzernamen ist bereits eine normale Benutzerzuordnung vorhanden. Soll diese durch eine Ausschlusszuordnung ersetzt werden?",
  "REPLACE_USER_EXCLUSION_CONFIRMATION": "Für diesen Benutzernamen ist bereits eine Ausschlusszuordnung vorhanden. Soll diese durch eine normale Benutzerzuordnung ersetzt werden?",
  "REQUIRED_FIELD_ERROR": "Dieses Feld ist erforderlich",
  "REVERT": "Wiederherstellen",
  "REVERT_CHANGES": "Änderungen Aufheben",
  "ROLE_FOR_IMPORT": "Rolle für Import",
  "ROLES_PERMISSION_ENABLED_HEADER": "Aktiviert",
  "ROLES_PERMISSION_NAME_HEADER": "Vorgang",
  "SAVE": "Speichern",
  "SAVE_MAPPING": "Mapping Speichern",
  "saveOutputSetting": "Üben Sie Voreinstellungen aus (Konvertierung und bilden PDF)",
  "SEARCH": "Suchen",
  "SEARCH_BASE": "Suchbasis",
  "SEARCH_RESULTS": "Suchergebnisse",
  "SECURITY_GROUPS": "Sicherheitsgruppen",
  "SELECT": "Auswählen",
  "SEND_DIAGNOSTIC_DATA": "Diagnosebericht an Portfolio DAM senden",
  "SERVER_DATA_DEFAULT_WORK_LOCATION_IS": "Standard-Arbeitsort: ",
  "SERVER_RESTART_REQUIRED": "Für das Wirksamwerden der Änderungen muss der Server neu gestartet werden.",
  "SERVER_STATE_ERROR": "Fehler: Genaue Details finden Sie im Verwaltungsprotokoll",
  "SERVER_STATE_STARTED": "Wird ausgeführt",
  "SERVER_STATE_STARTING": "Starten",
  "SERVER_STATE_STOPPED": "Gestoppt",
  "SERVER_STATE_STOPPING": "Stoppen",
  "SERVER_STATE_UNKNOWN": "Unbekannt",
  "SERVICE_BROWSER": "Service-Browser",
  "SK_ENGINE_APPAREL": "Kleid",
  "SK_ENGINE_CELEBRITIES": "Berühmtheiten",
  "SK_ENGINE_FOOD": "Lebensmittel",
  "SK_ENGINE_GENERAL": "Allgemeines",
  "SK_ENGINE_LOGO": "Logo",
  "SK_ENGINE_MODERATION": "Moderation",
  "SK_ENGINE_NSFW": "NSFW",
  "SK_ENGINE_TRAVEL": "Reise",
  "SK_ENGINE_WEDDINGS": "Hochzeiten",
  "SSL_HANDSHAKE_ERROR": "Fehler bei SSL-Handshake; stellen Sie sicher, dass die Anschluss- und SSL-Einstellungen korrekt sind.",
  "STARTS_WITH": "beginnt mit",
  "STATE_OR_PROVINCE": "Bundesland",
  "STATUS": "Status",
  "STATUS_ADMIN_LOG": "Verwaltungsprotokoll",
  "STATUS_API_VERSION_LABEL": "API",
  "STATUS_API_STATE_LICENSED": "Lizenziert",
  "STATUS_API_STATE_UNLICENSED": "Nicht lizenziert",
  "STATUS_CLEAR_ADMIN_LOG": "Verwaltungsprotokoll löschen",
  "STATUS_CONNECTED_USERS": "Verbundene Benutzer",
  "STATUS_MAX_ALLOWED_CONNECTIONS": "Maximale Verbindungen",
  "STATUS_MEDIA_ENGINE_VERSION_LABEL": "Media Engine",
  "STATUS_MEDIA_ENGINES_ACTIVE": "Aktiv",
  "STATUS_MEDIA_ENGINES_LABEL": "Media Engines",
  "STATUS_RESTART_SERVER": "Portfolio neu starten",
  "STATUS_SEAT_USAGE": "Platznutzung",
  "STATUS_SERVER_STATE": "Portfolio-Zustand",
  "STATUS_SERVER_VERSION_LABEL": "Portfolio",
  "STATUS_START_SERVER": "Portfolio starten",
  "STATUS_STOP_SERVER": "Portfolio stoppen",
  "STATUS_PROBLEMS_DETECTED": "Erkannte Probleme:",
  "STATUS_MSG_STARTUP_DRIVE_SPACE_UNDER_MINIMUM": "Die verbleibende Startfestplattenkapazität unterschreitet {minSpace} GB.",
  "STATUS_MSG_WORK_FOLDER_DOES_NOT_EXIST": "Der Arbeitsordner ist nicht vorhanden oder zugreifbar.",
  "STATUS_MSG_WORK_FOLDER_NOT_WRITEABLE": "Der Portfolio-Server kann nicht in den Arbeitsordner schreiben.",
  "STATUS_MSG_WORK_FOLDER_NOT_READABLE": "Der Portfolio-Server kann nicht aus dem Arbeitsordner lesen.",
  "STATUS_MSG_WORK_FOLDER_NOT_SYMLINKABLE": "Der Portfolio-Server kann keine Symlinks im Arbeitsordner erzeugen.",
  "STATUS_MSG_WORK_FOLDER_DISK_SPACE_LOW": "Die verbleibende Arbeitsordner-Festplattenkapazität unterschreitet {minSpace} GB.",
  "STATUS_MSG_WORK_FOLDER_CANT_GET_STATUS": "Der Arbeitsordnerstatus kann nicht abgerufen werden.",
  "STATUS_MSG_ELASTICSEARCH_INDEX_STATUS_RED": "Der Status für den Elasticsearch-Index {index} ist rot.",
  "STATUS_MSG_ELASTICSEARCH_INDEX_UNINITIALIZED_SHARDS": "Der Elasticsearch-Index {index} hat nicht initialisierte Shards.",
  "STATUS_MSG_ELASTICSEARCH_INDEX_NOT_ALL_SHARDS_ACTIVE": "Nicht alle Shards sind für den Elasticsearch-Index {index} aktiv.",
  "STATUS_MSG_ELASTICSEARCH_CANT_GET_STATUS": "Der Elasticsearch-Status kann nicht abgerufen werden.",
  "STATUS_MSG_CANT_GET_ERRORS_FROM_SERVER": "Fehler können nicht vom Portfolio-Server abgerufen werden.",
  "STATUS_MSG_STARTUP_FAILED": "Start fehlgeschlagen",
  "STATUS_MSG_CANT_GET_SERVER_HEALTH": "Serverzustand kann nicht aktualisiert werden.",
  "STATUS_MSG_NATIVE_AGENT_NOT_RUNNING": "Die native Agent-Server-Komponente wird nicht ausgeführt.",
  "SUBJECT_ALTERNATIVE_NAMES": "Betreff Alternative Namen",
  "SUBMIT": "Absenden",
  "swedish": "Schwedisch",
  "SYNC_DAILY": "Täglich synchronisieren",
  "SYNCHRONIZE_NOW": "Jetzt synchronisieren",
  "TARGET_CATALOG": "Zielkatalog",
  "THIS_LOCALE": "de",
  "TRUE_LABEL": "Wahr",
  "TOKEN": "Token",
  "TOTAL_ASSETS": "Gesamte Assets",
  "TWO_LETTER_COUNTRY_CODE": "Ländercode mit zwei Buchstaben",
  "TYPE": "Art",
  "UNABLE_CONNECT_LDAP": "Verbindung mit LDAP/AD-Server nicht möglich.",
  "UNABLE_CONNECT_SERVER": "Verbindung mit Server nicht möglich.",
  "UNKNOWN_HOST_ERROR": "Die Verbindung mit dem Verzeichnisservice konnte aufgrund einer Host-Ausnahmebedingung nicht hergestellt werden. Prüfen Sie den Hostnamen.",
  "UNKNOWN_LDAP_USER_ERROR": "Kein Benutzer wurde im Identitätsservice mit den Kontonamen '{accountName}' gefunden.",
  "useCustomPresets": "Voreinstellungen des Konvertiervorgangs verwenden",
  "USE_SSL": "SSL verwenden",
  "USER_ACCOUNT": "Konto",
  "USER_CREATE": "Neuen Benutzer hinzufügen",
  "USER_DELETE": "Benutzer löschen",
  "USER_DELETE_CONFIRM": "Ausgewählte Benutzer löschen?",
  "USER_DELETE__DELETE_PRIVATE": "Dauerhaft gelöscht werden",
  "USER_DELETE__GALLERY_PROMPT": "Über \"Öffentlich machen\" werden alle privaten und schreibgeschützten Galerien dieses Benutzers zu öffentlichen Galerien. \"Alle privaten Galerien löschen\" löscht private Galerien und macht schreibgeschützte Galerien zu öffentlichen Galerien.",
  "USER_DELETE__GALLERY_PROMPT_1": "Die ausgechecktenArtikel der Nutzer werden zurückgegeben und zur Verfügung gestellt.",
  "USER_DELETE__GALLERY_PROMPT_2": "Die Nur-Lesen Gallerien der Nutzer werden veröffentlicht.",
  "USER_DELETE__GALLERY_PROMPT_3": "Die Privatgalerien der Nutzer sollten:",
  "USER_DELETE__MAKE_PUBLIC": "Veröffentlicht werden",
  "USER_DETAILS": "Benutzerdetails",
  "USER_IMPORT": "Benutzer importieren",
  "USER_IMPORT_ACCOUNT": "Benutzername",
  "USER_IMPORT_ACCOUNT_ATTR": "Kontoattribut",
  "USER_IMPORT_EMAIL_ATTR": "E-Mail-Attribut",
  "USER_IMPORT_IMPORT": "Importieren",
  "USER_IMPORT_IMPORT_SELECTED_USERS": "Ausgewählte Benutzer importieren",
  "USER_IMPORT_MODIFY_SEARCH": "Suche ändern",
  "USER_IMPORT_NAME_ATTR": "Kontonamensattribut",
  "USER_IMPORT_NOTES_ATTR": "Notizenattribut",
  "USER_IMPORT_PASSWORD": "Kontokennwort",
  "USER_IMPORT_PASSWORD_ATTR": "Kennwortattribut",
  "USER_IMPORT_SEARCH": "Suche",
  "USER_IMPORT_SEARCH_BASE": "Suchbasis",
  "USER_IMPORT_SEARCH_FILTER": "Suchfilter",
  "USER_IMPORT_SERVER_ADDRESS": "Serveradresse",
  "USER_IMPORT_SPECIFY_LDAP_SERVER": "LDAP Server angeben",
  "USER_LEVEL_ADMINISTRATOR": "Katalogadministrator",
  "USER_LEVEL_EDITOR": "Editor",
  "USER_LEVEL_NON_MEMBER": "--",
  "USER_LEVEL_PUBLISHER": "Herausgeber",
  "USER_LEVEL_READER": "Leser",
  "USER_MANAGE_CATALOGS": "Kataloge für ausgewählte Benutzer verwalten",
  "USER_MULT_USERS_SELECTED": "Mehrere Benutzer ausgewählt",
  "USER_NAME": "Benutzername",
  "USER_NEW_USER_DETAILS": "Neue Benutzerdetails",
  "USER_NEW_USER_INFO_MSG": "Zum Hinzufügen eines Benutzers zu bestimmten Katalogen, Kataloge > Benutzer.",
  "USER_NEW_USER_ADD_USER_TO_ALL_CATALOGS": "Benutzer zu allen Katalogen hinzufügen als:",
  "USER_NO_USERS_SELECTED": "Keine Benutzer ausgewählt",
  "USER_ONLINE": "Online",
  "USER_PASSWORD_TOO_SHORT": "Das Passwort muss aus mindestens einem Zeichen bestehen.",
  "USER_PASSWORDS_DO_NOT_MATCH": "Das Kennwortbestätigungsfeld muss mit dem Kennwortfeld übereinstimmen.",
  "USER_ROLE": "Zugriffsmodus",
  "USER_VIEW_DETAILS": "Benutzerdetails anzeigen/bearbeiten",
  "USERS": "Benutzer",
  "VALIDATION_FIELD_LENGTH_EXCEEDED": "Dieses Feld darf 255 Zeichen nicht überschreiten.",
  "VALIDATION_MUST_BE_NONEMPTY": "Dieses Feld ist erforderlich.",
  "VIEW_EDIT_MAPPINGS": "Zuweisungen anzeigen / bearbeiten",
  "General.OK": "OK",
  "General.Cancel": "Abbrechen",
  "PORT_TITLE": "Ports",
  "PORT_DEFAULT": "Standard:",
  "esp.port.admin-web-app": "Portfolio Admin HTTP-Anschluss",
  "esp.port.admin-web-app-ssl": "Portfolio Admin SSL-Anschluss",
  "esp.port.http": "Portfolio Server HTTP-Anschluss",
  "esp.port.ssl": "Portfolio Server SSL-Anschluss",
  "General.Save": "Speichern",
  "CATALOG_DETAILS_FILETYPES_TAB": "Speichertypen",
  "addAsset": "Assets hinzufügen",
  "canManageFieldLists": "Öffentliche Feldlisten verwalten",
  "canModifyFolderStructure": "Ordnerstrukturen ändern",
  "canMoveAssets": "Assets verschieben",
  "deleteAssetContents": "Original-Assets löschen",
  "deleteAssetFromCatalog": "Asset aus Katalog löschen",
  "modifyAssetProperties": "Asset-Felder aktualisieren",
  "synchronizeAutoSyncFolder": "Autosync-Ordner synchronisieren",
  "ASSETS": "Assets",
  "CATALOG_STORAGE_TYPE_S3": "S3",
  "CREATE_CATALOG": "Katalog erstellen",
  "STATUS_MSG_SYSTEM_MEMORY_BELOW_REQUIREMENTS": "Der Systemspeicher beträgt {value} GB; dieser Wert unterschreitet die Mindestanforderungen von {minGB} GB.",
  "STATUS_MSG_SYSTEM_MEMORY_POSSIBLY_INACCURATE": "Der von Portfolio berechnete Systemspeicher von {value} GB ist möglicherweise ungenau.",
  "AUTH.couldNotConnect": "Es konnte keine Verbindung zum Server hergestellt werden. Bitte prüfen Sie die Adresse.",
  "ERROR.serverUnavailable": "Der Portfolio-Server ist nicht verfügbar.",
  "ERROR.sessionExpired": "Ihre Sitzung ist abgelaufen.",
  "fileNotFound": "Die Datei wurde auf dem Datenträger nicht gefunden.",
  "ERROR.invalidSearchFailed": "Die Suche ist fehlgeschlagen, da es ein Problem mit der Anfrage gab.",
  "AUTH.loginFailed": "Nutzername und Kennwort waren falsch.",
  "FAULT_CODE.InsufficientPrivileges": "Zur Durchführung dieses Vorgangs reichen Ihre Berechtigungen nicht aus.",
  "unexpectedError": "Ein unerwarteter Fehler ist aufgetreten.",
  "ROLES_CREATE_ROLE_TITLE": "Rolle erstellen",
  "ROLES_DELETE_CONFIRM": "Möchten Sie die ausgewählte Rolle löschen?\nBenutzer mit dieser Rolle werden zu Lesern zurückgestuft.",
  "NOTIFICATION_SUCCESS_UPDATE": "Update erfolgreich",
  "DATA_COLLECTION_TITLE": "Analyse",
  "DATA_COLLECTION_RTI_OPT_OUT_LABEL": "Ich stimme der Weitergabe der Anwendungsnutzungsdaten zu.",
  "DATA_COLLECTION_RTI_OPT_OUT_TEXT": "Helfen Sie uns, die besten Lösungen anzubieten, indem Sie die Nutzung der Anwendung mit uns teilen.\n\nWenn Sie akzeptieren, helfen Sie uns wichtige Informationen zu sammeln, die uns unterstützen, die Qualität weiter zu verbessern und Optimierungen vorzunehmen. Die Informationen werden helfen uns, Ihre Anforderungen an die Lösung zu verstehen.\n\nSie können Ihre Meinung jederzeit ändern und das Teilen von Informationen beenden.\n\nWeiterführende Informationen dazu, wie wir Ihre Daten nutzen und wie Sie sich künftig anderweitig entscheiden können, entnehmen bitte dem Artikel auf der Hilfe-Seite: ",
  "DATA_COLLECTION_HELP_URL": "https://help.portfoliodam.com/hc/de/articles/1260804371029",
  "CREATE_USER": "Benutzer erstellen",
  "CATALOG_FILES_TAB_TITLE": "Aufnehmen",
  "FIELD_CATEGORY_ALL": "Alle aktiven Felder",
  "FIELD_CATEGORY_FONTSENSE": "Portfolio DAM Font Sense",
  "FIELD_DEF.cataloged": "Katalogisiert am",
  "FIELD_DEF.catalogedBy": "Katalogisiert von",
  "FIELD_DEF.colorMode": "Farbmodus",
  "FIELD_DEF.isPanoramic": "Panoramisch",
  "FIELD_DEF.created": "Erstellt am",
  "FIELD_DEF.directoryPath": "Verzeichnispfad",
  "FIELD_DEF.documentText": "Dokumententext",
  "FIELD_DEF.filename": "Dateiname",
  "FIELD_DEF.fileDescription": "Beschreibung",
  "FIELD_DEF.fileSize": "Dateigröße",
  "FIELD_DEF.geometry": "Geo - Karte",
  "FIELD_DEF.height": "Höhe",
  "FIELD_DEF.horizontalResolution": "Horizontal Resolution",
  "FIELD_DEF.keywords": "Schlüsselwörter",
  "FIELD_DEF.lastModified": "Modifiziert",
  "FIELD_DEF.lastUpdated": "Geändert",
  "FIELD_DEF.aliasMac": "Alias (Mac)",
  "FIELD_DEF.creatorMac": "Erstellungsprogramm (Mac)",
  "FIELD_DEF.fileTypeMac": "Dateityp (Mac)",
  "FIELD_DEF.zoneMac": "Zone (Mac)",
  "FIELD_DEF.multipageCount": "Anzahl von Seiten",
  "FIELD_DEF.numBands": "Zahl der Bänder",
  "FIELD_DEF.path": "Pfad",
  "FIELD_DEF.ItemID": "Asset-ID",
  "FIELD_DEF.shortFilenameWin": "Kurzer Dateiname (Win)",
  "FIELD_DEF.thumbnailSize": "Thumbnailgröße",
  "FIELD_DEF.updatedBy": "Geändert von",
  "FIELD_DEF.verticalResolution": "Vertikale Auflösung",
  "FIELD_DEF.volume": "Volume",
  "FIELD_DEF.watermarkURL": "Wasserzeichen-URL",
  "FIELD_DEF.watermarked": "Mit Wasserzeichen",
  "FIELD_DEF.width": "Breite",
  "FIELD_DEF.SuggestedKeywords": "Smart Keywords",
  "REFRESH": "Aktualisieren",
  "ALL_CATALOGS": "Alle Kataloge",
  "ALL_SITES": "Alle Sites",
  "ASSET_DOWNLOADS": "Assets - Häufigste Downloads",
  "ASSET_PREVIEWS": "Assets - Häufigste Voransicht",
  "ASSET_UPLOADS": "Assets - Uploads",
  "DOWNLOAD_REPORT": "Report downloaden",
  "FILE_TYPES": "Speichertypen",
  "FILE_TYPES_SECTION_TITLE": "Speichertypen",
  "FILE_TYPES_ERROR_NAME_EXISTS": "Der '{name}‘-Name stimmt mit dem Namen des vorhandenen Dateityps überein.",
  "FILE_TYPES_LABEL_RESTORE_DEFAULTS": "Auf Standardwerte zurücksetzen",
  "FILE_TYPES_PROMPT_DISCARD_CHANGES": "Ausstehende Änderungen verwerfen?",
  "FILE_TYPES_ADD_FILE_TYPE": "Dateityp hinzufügen",
  "FILE_TYPES_UPDATE_FILE_TYPE": "Dateityp aktualisieren",
  "FILE_TYPES_EXTENSIONS": "Erweiterungen",
  "FROM": "Von",
  "SITE": "Site",
  "KEYWORD_STATISTICS": "Keyword Statistik",
  "NETPUBLISH_MOST_DOWNLOADED": "NetPublish - beliebteste Downloads",
  "NETPUBLISH_USAGE": "NetPublish - Nutzung",
  "REPORT_DESCRIPTION_ASSET_PREVIEWS": "Dieser Bericht enthält alle Asset-Voransichten und wie häufig jeder Posten angesehen wurde.",
  "REPORT_DESCRIPTION_ASSET_UPLOADS": "Dieser Bericht enthält alle hochgeladenen Assets, die Benutzer, die diese hochgeladen haben, und den Zeitpunkt.",
  "REPORT_DESCRIPTION_DOWNLOADED": "Dieser Bericht zeigt welche Posten heruntergeladen wurden und wie oft jeder heruntergeladen wurde.",
  "REPORT_DESCRIPTION_KEYWORD": "In diesem Bericht werden alle Schlüsselwörter in einem Katalog identifiziert und wie viele Posten Ihnen zugeordnet sind.",
  "REPORT_DESCRIPTION_USAGE": "Dieser Bericht zeigt, welche Nutzer welche Posten heruntergeladen haben und wann.",
  "SEARCH_TERMS": "Suchtypen",
  "TO": "Bis",
  "VIEW_REPORT": "Bericht anzeigen",
  "NP_SITES": "NetPublish-Seiten",
  "REPORT_NAME_DELETED_BY": "Assets - Löschungen",
  "REPORT_NAME_DOWNLOADED_BY": "Assets - Downloads",
  "REPORT_DESCRIPTION_DELETED_BY": "Dieser Bericht enthält alle gelöschten Assets, die Benutzer, die diese gelöscht haben, und den Zeitpunkt.",
  "REPORT_DESCRIPTION_DOWNLOADED_BY": "Dieser Bericht enthält alle heruntergeladenen Assets, die Benutzer, die diese heruntergeladen haben, und den Zeitpunkt.",
  "CATALOG_SAVE_TEMPLATE_TITLE": "Katalogvorlage erstellen",
  "BACKUP_FILES_LABEL": "Backup-Dateien",
  "CONFIGURE_EMAIL_LINK": "E-Mail-Benachrichtigungen konfigurieren...",
  "NP_SOURCE": "Quelle",
  "NOTIFICATION_FAILURE_UPDATE": "Update nicht erfolgreich",
  "FIELD_FORM_LABEL_PRECISION_MAX": "Max",
  "REPORT_DESCRIPTION_FILE_TYPES": "Dieser Bericht enthält die häufigsten Speichertypen und deren Festplattenbelegung.",
  "REPORT_DESCRIPTION_SEARCH_TERMS": "Dieser Bericht enthält die häufigsten Wörter und Sätze, nach denen Ihre Benutzer suchen.",
  "DUPLICATE_FIELD_NAME_ERROR": "Doppelte Feldnamen",
  "NO_CATALOGS_EXIST": "Es sind keine Kataloge vorhanden.\n\n-klicken Sie auf die Schaltfläche +, um einen Katalog zu erstellen.",
  "CATALOG_CHANGE_LEVEL_FOR_SELECTED_USERS": "Rollentausch",
  "REMOVE_USERS_FROM_CATALOG_CONFIRM_TITLE": "Mitgliedschaft aufheben",
  "REMOVE_USERS_FROM_CATALOG_CONFIRM_MSG": "Den Nutzer aus dem Katalog entfernen? \nDie aus diesem Katalog ausgechecktenArtikel werden zurückgegeben und zur Verfügung gestellt.",
  "CHANGE_USERS_ROLE_IN_CATALOG_CONFIRM_MSG": "Möchten Sie die Rolle des Benutzers im Katalog wirklich ändern? Dieses Vorgehen kann die Daten des Benutzers löschen, wenn die neue Rolle über eingeschränkte Zugriffsrechte oder Berechtigungen verfügt.",
  "DIRECTORY_SERVICE_QUERY_PENDING_MESSAGE": "Abfragen. Das kann ein paar Minuten dauern...",
  "FIELD_DELETE_CONFIRM_MSG": "Möchten Sie das ausgewählte Feld löschen?",
  "FILE_TYPES_PROMPT_RESTORE_DEFAULTS": "Alle Dateitypen auf ihre Standardwerte zurücksetzen?",
  "DIRECTORY_SERVICE_BROWSE_FILTER_LABEL": "Filter",
  "DIRECTORY_SERVICE_BROWSE_ITEMS_LABEL": "AD-Benutzer und -Gruppen",
  "DIRECTORY_SERVICE_SAVE_MAPPINGS": "Speichern und synchronisieren",
  "DIRECTORY_SERVICE_REMOVE_MAPPING": "Zuordnung entfernen",
  "DIRECTORY_SERVICE_MAPPING_SOURCE_LABEL": "Portfolio-Benutzerimporte",
  "DIRECTORY_SERVICE_NO_MAPPINGS_LABEL": "Keine Zuordnungen.\n\nUm eine Zuordnung zu erstellen, wählen Sie links einen Benutzer oder eine Gruppe aus und klicken Sie auf 'Zuordnung erstellen'.",
  "NOTIFICATION_FAILURE_ADD": "Hinzufügen fehlgeschlagen",
  "FIELD_ADD_EXTRACT_METADATA": "Extraktionszuordnung hinzufügen",
  "FIELD_MULTIPLE_EMBED_WARNING": "Es wird mehr als ein Feld in",
  "CATALOG_SK_KEYWORD_ON_CATALOG_LABEL": "Smart Keyword, neu katalogisierte Assets",
  "LIC_CLICK_TO_UPGRADE": "Hier klicken, um den Portfolio Server zu aktualisieren",
  "LIC_MAINTENANCE_END_DATE": "Wartungs- / Abonnement-Enddatum",
  "LIC_SEAT_DISPLAY": "Benutzer-Lizenzen",
  "LIC_ACTIVATE": "Portfolio aktivieren (Anmeldedaten erforderlich)",
  "LIC_CLICK_TO_ACTIVATE": "Hier klicken, um den Portfolio Server zu aktivieren",
  "LIC_CLICK_TO_USE": "Hier klicken, um Portfolio für einen begrenzte Zeitraum zu verwenden",
  "LIC_TRIAL": "Portfolio testen (Seriennummer erforderlich)",
  "EXTENSIS_CONTACT_US_URL": "https://www.portfoliodam.com/de/contact-us-form?utm_source=internal-product-link&utm_medium=buy-upgrade-option",
  "EXTENSIS_SUPPORT_URL": "https://help.portfoliodam.com/hc/de/requests/new",
  "LIC_ERROR_GET_ACCOUNT": "Beim Abrufen Ihres Portfolio DAM-Kontos ist ein Problem aufgetreten.",
  "LIC_ERROR_GET_LICENSES": "Beim Abrufen Ihrer Lizenzen von Portfolio DAM ist ein Problem aufgetreten.",
  "CHANGE": "Ändern",
  "GLOBAL_SETTINGS_FOLDER_SHUT_DOWN_MESSAGE": "Um diesen Ordner zu ändern, fahren Sie zunächst den Portfolio-Server herunter.",
  "MEDIA_ENGINES_COLUMN_TEST": "Prüfen",
  "ROLES_PERMISSIONS": "Berechtigungen",
  "NO_SITES_EXIST_1": "Es sind keine NetPublish-Sites vorhanden.",
  "NO_SITES_EXIST_2": "Verwenden Sie die Veröffentlichen-Option in Portfolio, um Sites zu erstellen und zu veröffentlichen.",
  "MEDIA_ENGINE_NOT_OPERATIONAL": "Kein Zugriff auf die Media-Engine.",
  "MEDIA_ENGINE_OPERATIONAL": "Die Media-Engine ist betriebsbereit.",
  "LIC_SET_EXTENSIS_ACCOUNT": "Portfolio DAM-Konto einrichten",
  "LIC_ACCOUNT": "E-Mail-Adresse",
  "LIC_PASSWORD": "Kennwort",
  "CERTS_TITLE": "SSL-Zertifikat",
  "LIC_SYSTEM_ID": "System-ID",
  "LIC_SET_ACCOUNT_ERROR": "Beim Einrichten Ihres Portfolio DAM-Kontos ist ein Problem aufgetreten. Bitte überprüfen Sie die Zugangsdaten und versuchen Sie es erneut.",
  "LIC_SET_SYSTEM_TITLE": "Wählen Sie Ihr Portfolio DAM-System",
  "NP_DELETE_SITE_CONFIRMATION": "Möchten Sie die Seite dauerhaft löschen?",
  "NP_SITE_DELETE_LABEL": "Seite löschen",
  "NP_SITE_ENABLED_LABEL": "Seite aktiviert",
  "CERT_CREATE_REQUEST": "Zertifikatanforderung erstellen",
  "CERT_DOWNLOAD": "Herunterladen",
  "CERT_EXPIRATION_DATE": "Gültigkeitsdatum",
  "CERT_IMPORT": "Ein Zertifikat importieren",
  "CERT_ISSUER": "Aussteller",
  "CERT_OWNER": "Eigentümer",
  "CERT_PENDING_REQUEST": "Ausstehende Zertifikatsanforderung",
  "CERTIFICATE_STATUS_INVALID": "Ungültiges Zertifikat",
  "CERTIFICATE_STATUS_SELF_SIGNED": "Ungültiges Zertifikat: Selbst-signiert",
  "CERTIFICATE_STATUS_EXPIRED": "Zertifikat abgelaufen",
  "CERTIFICATE_STATUS_IMPORTED": "Zertifikat importiert",
  "CERT_DELETE_CONFIRMATION": "Sind Sie sicher, dass Sie die Zertifikatsanforderung löschen möchten? Dieser Vorgang kann nicht rückgängig gemacht werden.",
  "DIAGNOSTICS_TITLE": "Diagnosen",
  "DIAGNOSTICS_NO_PROBLEMS": "Keine Probleme gefunden",
  "SK_ENGINE_ART_STYLE": "Kunststil",
  "SK_ENGINE_ART_SUBJECT": "Kunstgegenstand",
  "SK_ENGINE_ART_MOVEMENT": "Kunstbewegung",
  "CERT_FILE": "Zertifikatdatei",
  "CERT_FILE_INT_1": "Zwischenzertifikat 1",
  "CERT_FILE_INT_2": "Zwischenzertifikat 2",
  "CERT_FILE_PASSWORD": "Zertifikat-Passwort",
  "CERT_FILE_PASSWORD_HELP": "Wenn Ihr Zertifikat ein Passwort hat, geben Sie es bitte hier ein",
  "CERT_FILE_PROMPT": "Auswählen...",
  "CERT_FILE_ROOT": "Grundzertifikat",
  "CERT_IMPORT_SUCCEEDED": "Das Zertifikat wurde erfolgreich importiert. Starten Sie den Portfolio-Server und die Portfolio-Admin-Dienste neu, um das Zertifikat zu verwenden.",
  "CERT_IMPORT_FAILED_READING_PKCS12": "Der Server konnte das PKCS12-Zertifikat nicht lesen. Prüfen Sie das Passwort.",
  "CERT_IMPORT_FAILED_INTERMEDIATE1": "Das Zwischenzertifikat 1 konnte nicht importiert werden.",
  "CERT_IMPORT_FAILED_INTERMEDIATE2": "Das Zwischenzertifikat 2 konnte nicht importiert werden.",
  "CERT_IMPORT_FAILED_ROOT": "Das Wurzelzertifikat konnte nicht importiert werden.",
  "DIRECTORY_SERVICE_CONFIG_TITLE": "Verzeichnisdienst-Konfiguration",
  "DIRECTORY_SERVICES_TITLE": "Verzeichnisdienst",
  "DIRECTORY_SERVICE_MAPIINGS": "Verzeichniselemente für Portfolio-Zuordnungen",
  "DIRECTORY_SERVICE_MAPIINGS_TITLE": "Zuordnungen",
  "PDL_noPredefinedValues": "Keine vordefinierten Werte",
  "PDL_editPredefinedListPlaceholder": "Vordefinierte Liste bearbeiten",
  "PDL_importPredefinedValues": "Vordefinierte Werte importieren",
  "PDL_exportPredefinedValues": "Vordefinierte Werte exportieren",
  "PDL_removeNestedValueConfirmation": "Markierte Werte löschen?\nSie enthalten verschachtelte Werte, die ebenfalls gelöscht werden.",
  "PDL_wrongPdlImportFormat": "Die gewählte Datei enthält keine Textdaten. Wählen Sie bitte eine Textdatei.",
  "LIC_SET_ACCOUNT": "Konto Einrichten",
  "LIC_REMOVE_ACCOUNT": "Konto Entfernen",
  "LIC_CONTACT_CUSTOMER_SUCCESS_1": "Wenn Sie Hilfe bei der Erneuerung Ihres Kontos benötigen, kontaktieren Sie uns bitte unter",
  "LIC_CONTACT_CUSTOMER_SUCCESS_2": "Ihr Customer Success Manager wird Sie innerhalb eines Werktages kontaktieren."
};
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/translations/de.js